// components
import {showToastCustom} from "../../../components/toast/customToast";

// actions
import {setLoading} from "../generalActions/mainActions";
import {changeListItem} from "../generalActions/listActions";

// services
import {notificationActivityService} from "../../../jwt/_services/comunication/notificationActivityService";

// labels
import {error} from "../../../components/i18n/i18n";


export const add = (data) => ( dispatch ) => {
    dispatch(setLoading(true))

    notificationActivityService.add(data)
        .then( result => {
            if(result?.status)
                dispatch( changeListItem(result) )
        })
        .catch( e => {
            showToastCustom(error, e);
            console.log("Error",e)
        })
        .finally(() => dispatch(setLoading(false)))
}

export const remove = (data) => ( dispatch ) => {
    dispatch(setLoading(true))

    notificationActivityService.remove(data)
        .then( result => {
            if(result?.status)
                dispatch( changeListItem(result) )
        })
        .catch( e => {
            showToastCustom(error, e);
            console.log("Error",e)
        })
        .finally(() => dispatch(setLoading(false)))
}